export default __webpack_public_path__ + "static/media/Mask Group 2.80528087.svg";